// src/components/Checklist.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Checklist = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // goes back to previous page
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px", height: "100vh" }}>
      {/* Back button bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 16px",
          borderBottom: "1px solid #ddd",
          background: "#fff",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <button
          onClick={handleBackClick}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            background: "#f9f9f9",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          <ArrowLeft size={16} />
          Back
        </button>
        <h3 style={{ margin: 0, flex: 1, textAlign: "center" }}>
          📋 Checklist
        </h3>
      </div>

      {/* Checklist iframe */}
      <div style={{ marginTop: "20px", width: "100%", height: "85vh" }}>
        <iframe
          src="https://ph-studio-checklist.vercel.app/"
          title="Checklist"
          width="100%"
          height="100%"
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        ></iframe>
      </div>
    </div>
  );
};

export default Checklist;
